const React = require('react');
const PropTypes = require('prop-types');
const { formatText } = require('core/i18n').i18n;
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { formatValue } = require('../utilities/valueFormater');

const CumulativeReturnTable = ({
    benchmark: trailingPerformanceBenchmark,
    data: trailingPerformance,
}) => (
    <OKTable>
        <thead>
            <OKTableRow asHeader>
                <OKTableCell />
                <OKTableCell>
                    <b>{formatText('fundsCard-month1').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-month3').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-month6').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-YTD').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-year1').toUpperCase()}</b>
                </OKTableCell>
                <OKTableCell>
                    <b>{formatText('fundsCard-year3Act').toUpperCase()}</b>
                </OKTableCell>
            </OKTableRow>
        </thead>
        <tbody>
            <OKTableRow>
                <OKTableCell>
                    {formatText('fundsCard-profitability').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {trailingPerformance.return.some(
                            r => r.timePeriod === 'M1',
                        )
                            ? `${formatValue(
                                  Number(
                                      trailingPerformance.return.find(
                                          r => r.timePeriod === 'M1',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {trailingPerformance.return.some(
                            r => r.timePeriod === 'M3',
                        )
                            ? `${formatValue(
                                  Number(
                                      trailingPerformance.return.find(
                                          r => r.timePeriod === 'M3',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {trailingPerformance.return.some(
                            r => r.timePeriod === 'M6',
                        )
                            ? `${formatValue(
                                  Number(
                                      trailingPerformance.return.find(
                                          r => r.timePeriod === 'M6',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformance.return.some(r => r.timePeriod === 'M0')
                        ? `${formatValue(
                              Number(
                                  trailingPerformance.return.find(
                                      r => r.timePeriod === 'M0',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {trailingPerformance.return.some(
                            r => r.timePeriod === 'M12',
                        )
                            ? `${formatValue(
                                  Number(
                                      trailingPerformance.return.find(
                                          r => r.timePeriod === 'M12',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
                <OKTableCell>
                    <b>
                        {trailingPerformance.return.some(
                            r => r.timePeriod === 'M36',
                        )
                            ? `${formatValue(
                                  Number(
                                      trailingPerformance.return.find(
                                          r => r.timePeriod === 'M36',
                                      ).value,
                                  ),
                              )}%`
                            : '-'}
                    </b>
                </OKTableCell>
            </OKTableRow>
            <OKTableRow>
                <OKTableCell>
                    {formatText('fundsCard-benchmark').toUpperCase()}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M1',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M1',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M3',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M3',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M6',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M6',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M0',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M0',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M12',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M12',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
                <OKTableCell>
                    {trailingPerformanceBenchmark.trailingPerformance[0].return.some(
                        r => r.timePeriod === 'M36',
                    )
                        ? `${formatValue(
                              Number(
                                  trailingPerformanceBenchmark.trailingPerformance[0].return.find(
                                      r => r.timePeriod === 'M36',
                                  ).value,
                              ),
                          )}%`
                        : '-'}
                </OKTableCell>
            </OKTableRow>
        </tbody>
    </OKTable>
);

CumulativeReturnTable.propTypes = {
    benchmark: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
};

module.exports = CumulativeReturnTable;
